<template>
  <div class="flex flex-wrap gap-6 pb-4 justify-center">
    <div v-for="i in 8" :key="i" class="w-full sm:w-[250px] space-y-3 animate-pulse">
      <div class="bg-zinc-800 rounded-lg aspect-[3/4] w-full"></div>
      <div class="space-y-2">
        <div class="h-4 bg-zinc-800 rounded w-3/4"></div>
        <div class="h-3 bg-zinc-800 rounded w-1/2"></div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
